'use client'
import { useBackNavigation } from '@/hooks/useBackNavigation'
import Image from 'next/image'

export default function TermsOfServices() {
  const handleBack = useBackNavigation()

  return (
    <div>
      <h1 className="text-7xl font-bold text-chart-3 mb-8 hidden md:block">Terms of Services</h1>
      <div className="bg-white rounded-xl shadow-none md:shadow p0 md:p-6 mb-0 md:mb-8">
        <p className="mb-4">
          Welcome to Curlified, an online platform operated by <b>CURLIFIED PRIVATE LIMITED</b>. By accessing or using our Site, you agree to be bound by the following Terms of Service ("Terms"). If you do not agree to these Terms, please do not use our Site.
        </p>
        <b>Intellectual Property:</b>
        <p className="mb-4">
          All content on our Site, including text, graphics, logos, images, and software, is the property of <b>CURLIFIED PRIVATE LIMITED</b> or its content suppliers and is protected by Indian and international copyright laws. The Curlified name and logo are trademarks of <b>CURLIFIED PRIVATE LIMITED</b>, and you may not use them without our prior written consent.
        </p>
        <b>Use of Site:</b>
        <p className="mb-4">
          You may only use our Site for lawful purposes and not in any way that violates any applicable laws, regulations, or third-party rights. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account. We reserve the right to terminate or suspend your account at any time, with or without notice.
        </p>
        <b>Privacy Policy:</b>
        <p className="mb-4">
          Please review our Privacy Policy to understand how we collect, use, and disclose information about our users.
        </p>
        <b>Payment and Billing:</b>
        <p className="mb-4">
          We accept various payment methods, and by providing payment information, you represent and warrant that you are authorized to use the payment method and that the information you provide is accurate and complete. You agree to pay all fees and charges associated with your use of the Site, including any applicable taxes.
        </p>
        <b>Cancellation and Returns:</b>
        <p className="mb-4">
          You may cancel your order before it has been shipped, and we offer returns and exchanges on most products within 30 days of delivery. Please review our Cancellation and Returns Policy for more information.
        </p>
        <b>Limitation of Liability:</b>
        <p className="mb-4">
          Curlified Private Limited and its affiliates shall not be liable for any damages arising from the use of the Site, including but not limited to direct, indirect, incidental, punitive, and consequential damages.
        </p>
        <b>Indemnification:</b>
        <p className="mb-4">
          You agree to indemnify and hold <b>CURLIFIED PRIVATE LIMITED</b> and its affiliates harmless from any claims, damages, or expenses arising from your use of the Site or any breach of these Terms.
        </p>
        <b>Modification of Terms:</b>
        <p className="mb-4">
          We reserve the right to modify these Terms at any time, with or without notice. Your continued use of the Site after any such modifications constitutes your agreement to the updated Terms.
        </p>
        <b>Governing Law and Jurisdiction:</b>
        <p className="mb-4">
          These Terms shall be governed by and construed in accordance with the laws of India, and any disputes arising out of or related to these Terms shall be resolved exclusively in the courts of Bangalore, India. If you have any questions or concerns about these Terms of Service, please Contact Us at support@curlified.com.
        </p>
      </div>
    </div>
  )
}